import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { faqData } from "@/data/services";

export default function FAQPage() {
  useEffect(() => {
    document.title = "FAQ | Double D Trapping LLC | St. Augustine, FL";
  }, []);

  return (
    <>
      {/* Header */}
      <section className="bg-[#0F1A15] border-b border-[#1F2937] py-16 sm:py-20" data-testid="faq-page-header">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#D95D39] uppercase text-xs font-bold tracking-[0.2em] mb-4">FAQ</p>
          <h1 className="text-[#F8FAFC] font-black text-4xl sm:text-5xl tracking-tighter mb-4" data-testid="faq-page-title">
            Frequently Asked Questions
          </h1>
          <p className="text-[#9CA3AF] text-base sm:text-lg max-w-2xl leading-relaxed">
            You've Got Questions. We've Got 50 Years Worth of Answers.
          </p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="bg-[#0B110E] py-16 sm:py-20" data-testid="faq-accordion-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-3">
            {faqData.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-[#1F2937] rounded-sm bg-[#0F1A15] px-6 data-[state=open]:border-[#D95D39]/30"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-[#F8FAFC] font-bold text-sm sm:text-base text-left py-5 hover:no-underline hover:text-[#D95D39] [&[data-state=open]]:text-[#D95D39]">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#9CA3AF] text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0F1A15] border-t border-[#1F2937] py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
          <h2 className="text-[#F8FAFC] font-black text-2xl sm:text-3xl tracking-tighter mb-4">
            Still Have Questions?
          </h2>
          <p className="text-[#9CA3AF] text-sm sm:text-base mb-8">
            Call D. Davis directly. No call center, no voicemail.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:9042376253" data-testid="faq-call-btn">
              <button className="bg-[#D95D39] hover:bg-[#c04d2d] text-white font-black uppercase tracking-widest text-sm px-8 py-4 rounded-sm btn-glow inline-flex items-center gap-3 transition-colors duration-150">
                <Phone className="w-5 h-5" /> Call 904-237-6253
              </button>
            </a>
            <Link to="/contact" data-testid="faq-quote-btn">
              <button className="border border-[#1F2937] hover:border-[#D95D39] text-[#F8FAFC] font-bold uppercase tracking-widest text-sm px-8 py-4 rounded-sm inline-flex items-center gap-3 transition-colors duration-150">
                Get a Free Quote <ArrowRight className="w-4 h-4" />
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
